import React from "react"

import { Field, getIn } from "formik"

import { InputBase } from "@unlimint/admin-ui-kit"

const replaceNumber = (value) => {
  return String(value)
    .replace(/[^.\d]/g, "")
    .replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
}

export const InputField = ({
  name,
  label,
  disabled,
  cleanable = true,
  type = "text",
  size = "small",
  rows,
  isExponencial,
  isTooltipText = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form: { setFieldValue, touched, errors }, meta }) => (
        <InputBase
          type={isExponencial ? "text" : type}
          label={label}
          size={size}
          fullWidth
          name={name}
          error={!!errors[name] || !!getIn(errors, name)}
          helperText={errors[name] || getIn(errors, name)}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={isExponencial ? replaceNumber(field.value) : field.value}
          disabled={disabled}
          cleanable={cleanable}
          onClickEndIcon={() => setFieldValue(name, "")}
          multiline={!!rows}
          rows={rows}
          isTooltipText={isTooltipText}
        />
      )}
    </Field>
  )
}
